/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IEnderecosRepository } from "@/interface/enderecos-usuarios";

const enderecoRepository: IEnderecosRepository = {
  async criarNovoEndereco(accessToken, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const endereco = await Instance.post(`enderecos`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return endereco?.data;
  },
};

/**
 * EXPORTS
 */
export { enderecoRepository };
